import CommUtils from '@comm/script/utils'

const utils = {
  ...CommUtils,

  test1Fn () {
    console.log('workspace扩展函数+' + CommUtils.getCommonStr)
  }
}

export default utils



// WEBPACK FOOTER //
// ./src/workspace/common/utils/index.js